// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  animation: App-logo-spin infinite 20s linear;
  height: 80px;
}

.App-header {
  background-color: #222;
  height: 150px;
  padding: 20px;
  color: white;
}

.App-title {
  font-size: 1.5em;
}

.App-intro {
  font-size: large;
}

@keyframes App-logo-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.filter-attribute-id-select{
    padding-right: 0px;
}
.filter-attribute-val-select{
    padding-left: 0px;
}

.grid_container {
  display: grid;
  grid-template-columns: auto 1fr;
}

.tree-side{
    height: 100vh;
    overflow-y: scroll;
    z-index: 0;
    resize: horizontal;
    overflow-x: scroll;
    grid-row: 1;
    grid-column: 1;
    grid-width: 30%;
}

.testcase-side{
    height: 100vh;
    overflow-y: scroll;
    grid-row: 1;
    grid-column: 2;
    grid-width: 70%;
}

.clickable{
    cursor: pointer;
}

.testcase-section{
    padding: 15px;
    margin-bottom: 15px;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="text"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

/* Sticky footer styles
-------------------------------------------------- */
html {
  position: relative;
  min-height: 100%;
}
body {
  /* Margin bottom by footer height */
  margin-bottom: 60px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* Set the fixed height of the footer here */
  height: 60px;
  line-height: 60px; /* Vertically center the text there */
  background-color: #f5f5f5;
}


/* Custom page CSS
-------------------------------------------------- */
/* Not required for template or sticky footer method. */

body > .container {
  padding: 60px 15px 0;
}

.footer > .container-fluid {
  padding-right: 15px;
  padding-left: 15px;
}

code {
  font-size: 80%;
}


.bg-green {
    background-color: #135f38!important;
    #background-color: #13515f!important;
}

.edit-icon-visible {
    margin-left: 10px;
}

.edit-icon {
    margin-left: 10px;
    visibility: hidden;
}

b:hover .edit-icon {
    margin-left: 10px;
    visibility: visible;
}

h1:hover .edit-icon {
    margin-left: 10px;
    visibility: visible;
}

h5:hover .edit-icon {
    margin-left: 10px;
    visibility: visible;
}


.red {
    color: #da0000;
}

.project-card {
    margin-bottom: 20px;
}

.organization-card {
    margin-bottom: 20px;
}

.testsuite-card {
    margin-bottom: 20px;
}

.remove-filter-icon {
    margin-left: -29px;
}

.card-step {
    width: 100%;
}

.attribute-block {
     margin-bottom: 10px;
 }

.attachments-list {
  margin-bottom: 20px;
  margin-top: 20px;
}

.tab-badge {
    margin-left: 5px;
}

.launch-filter {
    margin-top: 20px;
}

.expectations {
    margin-top: 25px;
}

.testcase-inplace-buttons-down {
    margin-top: 10px;
}

.alert-message {
    position: absolute;

    z-index: 1;
    display: none;
    float: right;
}

.launch-summary-block {
     margin-bottom: 10px;
}

.launch-status-controls {
    margin-top: 50px;
}

.attributes-controls {
    margin-top: 20px;
}

.grouping-control {
    max-width: 38.2%;
}

.filter-control-row {
    margin-bottom: 10px;
}

.project-settings-control {
    margin-top: 30px;
}

.launcher-details {
    margin-top: 20px;
}

.restart-launch-control {
    margin-top: 20px;
}

.external-launch-link{
    margin-left: 5px;
}

.name-icon{
    margin-left: 20px;
    margin-right: 20px;
}

.events-filter {
    margin-top: 20px;
}

.broken-toggle {
    font-size: 10px;
}

.center-text {
    text-align: center;
}

.project-settings-section {
    margin-bottom: 30px;
}

.project-settings-launchers {
    margin-top: 15px;
    margin-left: 1px;
}

.launch-attr-stats {
    margin-top: 50px;
}

.launch-attr-stats-chart {
    margin-top: 30px;
}

.project-header {
    margin-top: 10px;
    margin-bottom: 20px;
}

.organization-header {
    margin-top: 10px;
    margin-bottom: 20px;
}


a.project-title-settings-link:link, a.project-title-settings-link:visited {
    color: black !important;
    font-size: 24px;
}

a.organization-title-settings-link:link, a.organization-title-settings-link:visited {
    color: black !important;
    font-size: 24px;
}

.launch-title {
    margin-top: 15px;
    margin-bottom: 20px;
}

.step {
    margin-bottom: 20px;
}

.create-user-form{
    width: 100%;
    max-width: 700px;
    padding: 15px;
    margin: auto;
}

.launch-form-spinner{
    margin-left: 220px;
}

.tox-notifications-container {
    display: none !important;
}

.rounded {
    border-radius: .8rem!important;
}

.inplace-display p {
    margin-bottom: 0rem;
}

.select-org {
    max-width: 600px;
    margin: auto;
    padding: 10px;
}

.org-form-block {
    margin-top: 40px;
    padding-bottom: 30px;
}

.org-form {
    max-width: 700px;
}

.org-users-form {
    margin-top: 20px;
}

.project-form {
    width: 100%;
    max-width: 600px;
    padding: 15px;
    margin: auto;
}

.project-form-block {
    margin-top: 40px;
}

.project-form-title {
    margin-bottom: 30px;
}

a.link-black, a.link-black:link, a.link-black:link:visited {
    color: black !important;
}

.hidden {
    display: none;
}

.testcase-id-in-title {
    font-size: 80%;
    margin-right: 15px;
}

table.tableUserProfile {
   border: 1px solid black;
}

th.headerUserProfile {
   border: 2px solid black;
}

td.cellUserProfile {
   border: 1px solid black;
}

.dropdown_menu {
   display: flex;
   flex-direction: column;
   width: 250px;
   text-align: left;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;oDACoD;AACpD;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,4CAA4C;EAC5C,YAAY;EACZ,iBAAiB,EAAE,qCAAqC;EACxD,yBAAyB;AAC3B;;;AAGA;oDACoD;AACpD,uDAAuD;;AAEvD;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;;AAGA;IACI,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;KACK,mBAAmB;CACvB;;AAED;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;;IAElB,UAAU;IACV,aAAa;IACb,YAAY;AAChB;;AAEA;KACK,mBAAmB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,YAAY;GACZ,gBAAgB;AACnB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 80px;\n}\n\n.App-header {\n  background-color: #222;\n  height: 150px;\n  padding: 20px;\n  color: white;\n}\n\n.App-title {\n  font-size: 1.5em;\n}\n\n.App-intro {\n  font-size: large;\n}\n\n@keyframes App-logo-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.filter-attribute-id-select{\n    padding-right: 0px;\n}\n.filter-attribute-val-select{\n    padding-left: 0px;\n}\n\n.grid_container {\n  display: grid;\n  grid-template-columns: auto 1fr;\n}\n\n.tree-side{\n    height: 100vh;\n    overflow-y: scroll;\n    z-index: 0;\n    resize: horizontal;\n    overflow-x: scroll;\n    grid-row: 1;\n    grid-column: 1;\n    grid-width: 30%;\n}\n\n.testcase-side{\n    height: 100vh;\n    overflow-y: scroll;\n    grid-row: 1;\n    grid-column: 2;\n    grid-width: 70%;\n}\n\n.clickable{\n    cursor: pointer;\n}\n\n.testcase-section{\n    padding: 15px;\n    margin-bottom: 15px;\n}\n\n.form-signin {\n  width: 100%;\n  max-width: 330px;\n  padding: 15px;\n  margin: auto;\n}\n\n.form-signin .form-control {\n  position: relative;\n  box-sizing: border-box;\n  height: auto;\n  padding: 10px;\n  font-size: 16px;\n}\n.form-signin .form-control:focus {\n  z-index: 2;\n}\n.form-signin input[type=\"text\"] {\n  margin-bottom: -1px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.form-signin input[type=\"password\"] {\n  margin-bottom: 10px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n/* Sticky footer styles\n-------------------------------------------------- */\nhtml {\n  position: relative;\n  min-height: 100%;\n}\nbody {\n  /* Margin bottom by footer height */\n  margin-bottom: 60px;\n}\n.footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  /* Set the fixed height of the footer here */\n  height: 60px;\n  line-height: 60px; /* Vertically center the text there */\n  background-color: #f5f5f5;\n}\n\n\n/* Custom page CSS\n-------------------------------------------------- */\n/* Not required for template or sticky footer method. */\n\nbody > .container {\n  padding: 60px 15px 0;\n}\n\n.footer > .container-fluid {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\ncode {\n  font-size: 80%;\n}\n\n\n.bg-green {\n    background-color: #135f38!important;\n    #background-color: #13515f!important;\n}\n\n.edit-icon-visible {\n    margin-left: 10px;\n}\n\n.edit-icon {\n    margin-left: 10px;\n    visibility: hidden;\n}\n\nb:hover .edit-icon {\n    margin-left: 10px;\n    visibility: visible;\n}\n\nh1:hover .edit-icon {\n    margin-left: 10px;\n    visibility: visible;\n}\n\nh5:hover .edit-icon {\n    margin-left: 10px;\n    visibility: visible;\n}\n\n\n.red {\n    color: #da0000;\n}\n\n.project-card {\n    margin-bottom: 20px;\n}\n\n.organization-card {\n    margin-bottom: 20px;\n}\n\n.testsuite-card {\n    margin-bottom: 20px;\n}\n\n.remove-filter-icon {\n    margin-left: -29px;\n}\n\n.card-step {\n    width: 100%;\n}\n\n.attribute-block {\n     margin-bottom: 10px;\n }\n\n.attachments-list {\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.tab-badge {\n    margin-left: 5px;\n}\n\n.launch-filter {\n    margin-top: 20px;\n}\n\n.expectations {\n    margin-top: 25px;\n}\n\n.testcase-inplace-buttons-down {\n    margin-top: 10px;\n}\n\n.alert-message {\n    position: absolute;\n\n    z-index: 1;\n    display: none;\n    float: right;\n}\n\n.launch-summary-block {\n     margin-bottom: 10px;\n}\n\n.launch-status-controls {\n    margin-top: 50px;\n}\n\n.attributes-controls {\n    margin-top: 20px;\n}\n\n.grouping-control {\n    max-width: 38.2%;\n}\n\n.filter-control-row {\n    margin-bottom: 10px;\n}\n\n.project-settings-control {\n    margin-top: 30px;\n}\n\n.launcher-details {\n    margin-top: 20px;\n}\n\n.restart-launch-control {\n    margin-top: 20px;\n}\n\n.external-launch-link{\n    margin-left: 5px;\n}\n\n.name-icon{\n    margin-left: 20px;\n    margin-right: 20px;\n}\n\n.events-filter {\n    margin-top: 20px;\n}\n\n.broken-toggle {\n    font-size: 10px;\n}\n\n.center-text {\n    text-align: center;\n}\n\n.project-settings-section {\n    margin-bottom: 30px;\n}\n\n.project-settings-launchers {\n    margin-top: 15px;\n    margin-left: 1px;\n}\n\n.launch-attr-stats {\n    margin-top: 50px;\n}\n\n.launch-attr-stats-chart {\n    margin-top: 30px;\n}\n\n.project-header {\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n\n.organization-header {\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n\n\na.project-title-settings-link:link, a.project-title-settings-link:visited {\n    color: black !important;\n    font-size: 24px;\n}\n\na.organization-title-settings-link:link, a.organization-title-settings-link:visited {\n    color: black !important;\n    font-size: 24px;\n}\n\n.launch-title {\n    margin-top: 15px;\n    margin-bottom: 20px;\n}\n\n.step {\n    margin-bottom: 20px;\n}\n\n.create-user-form{\n    width: 100%;\n    max-width: 700px;\n    padding: 15px;\n    margin: auto;\n}\n\n.launch-form-spinner{\n    margin-left: 220px;\n}\n\n.tox-notifications-container {\n    display: none !important;\n}\n\n.rounded {\n    border-radius: .8rem!important;\n}\n\n.inplace-display p {\n    margin-bottom: 0rem;\n}\n\n.select-org {\n    max-width: 600px;\n    margin: auto;\n    padding: 10px;\n}\n\n.org-form-block {\n    margin-top: 40px;\n    padding-bottom: 30px;\n}\n\n.org-form {\n    max-width: 700px;\n}\n\n.org-users-form {\n    margin-top: 20px;\n}\n\n.project-form {\n    width: 100%;\n    max-width: 600px;\n    padding: 15px;\n    margin: auto;\n}\n\n.project-form-block {\n    margin-top: 40px;\n}\n\n.project-form-title {\n    margin-bottom: 30px;\n}\n\na.link-black, a.link-black:link, a.link-black:link:visited {\n    color: black !important;\n}\n\n.hidden {\n    display: none;\n}\n\n.testcase-id-in-title {\n    font-size: 80%;\n    margin-right: 15px;\n}\n\ntable.tableUserProfile {\n   border: 1px solid black;\n}\n\nth.headerUserProfile {\n   border: 2px solid black;\n}\n\ntd.cellUserProfile {\n   border: 1px solid black;\n}\n\n.dropdown_menu {\n   display: flex;\n   flex-direction: column;\n   width: 250px;\n   text-align: left;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
